import React, { Component, Fragment } from 'react';
import { Nav, Button, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import NavigationLinks from '../config/NavigationLinks';
import GameData from "../mobx/GameData";
import { observe } from 'mobx';
import slugify from "slugify";

import './AppNavigation.scss';
import { EmbeddedEmulator } from "../components/EmbeddedEmulator";
import ApplicationState from "../mobx/ApplicationState";

export default class AppNavigation extends Component {

  lastClickedContainer = null;
  emulatorRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      emulatorVisible: false,
      preEmulatorVisible: false,
      preNavigationVisible: false,
      emulatorRefresh: 0
    };
  }

  componentDidMount() {
    this.gameDataCleanup = observe(GameData, () => {
      this.forceUpdate()
    });
    this.applicationStateCleanup = observe(ApplicationState, () => {
      this.forceUpdate()
    });

  }
  componentWillUnmount() {
    if (this.gameDataCleanup) {
      this.gameDataCleanup();
    }
    if (this.applicationStateCleanup) {
      this.applicationStateCleanup();
    }

  }

  async playGame() {
    if (ApplicationState.currentPageHasUnsavedChanges) {
      if (this.state.preEmulatorVisible) {
        this.setState({ preEmulatorVisible: false });
      } else {
        // Haven't seen this, so bail without showing.
        this.setState({ preEmulatorVisible: true });
        return;
      }
    }
    // Force a refresh of the emulator before showing it (aggressive);
    this.forceUpdate();
    this.setState({ emulatorVisible: true });
    ApplicationState.setEmulatorVisible();
  }

  async resetEmulator() {
    this.setState({ emulatorRefresh: this.state.emulatorRefresh + 1 });
  }

  skipLevel() {
    this.emulatorRef.current.skipLevel();
  }

  async closeEmulator() {
    this.setState({'emulatorVisible': false });
    ApplicationState.unsetEmulatorVisible();
  }

  async downloadGame() {
    const a = document.createElement('a');
    a.href = await GameData.getCurrentPatchedRom();
    a.download = slugify(GameData.currentGame.title) + '.nes';
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(a.href)
    }, 5000);
  }

  async runLocal() {
     fetch('/do-download', {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({'romInfo': await GameData.getCurrentPatchedRom(false, null, true), title: slugify(GameData.currentGame.title), smallRom: !!GameData.currentGame.smallRom})
    })
  }

  testUnsavedChanges(event) {
    if (ApplicationState.currentPageHasUnsavedChanges && this.lastClickedContainer === null) {
      event.preventDefault();
      this.lastClickedContainer = event.target;
      this.setState({preNavigationVisible: true});
      return;
    }

    // If you get here, that means you just navigated successfully. This definitely means there are no unsaved/dirty changes.
    ApplicationState.unsetCurrentPageUnsaved();
    ApplicationState.setNavClosed();
    // document.scrollTop = 0;
    window.scrollTo({top: 0, left: 0, behavior: 'auto'});
  }

  testIsActive(link, match, location) {
    if (link.isActive && location && location.pathname) {
      return link.isActive(link, location.pathname);
    } else if (location.pathname) {
      return link.href === location.pathname;
    }
  }

  render() {
    let navObjects = []
    let currentKey = 0;

    NavigationLinks.forEach(linkGroup => {
      if ((linkGroup.filter && !linkGroup.filter(null, GameData.currentGame)) || linkGroup.enabled === false) {
        return;
      }
      currentKey++;

      if (linkGroup.visible === false) { return; }
      if (linkGroup.divider) {
        navObjects.push(<hr key={'nav-item-' + currentKey} />);
        return;
      }

      if (linkGroup.title !== null) {
        const groupTitle = linkGroup.title.replace('{%gameTitle%}', GameData?.currentGame?.title);
        navObjects.push(<h6 key={'nav-item-' + currentKey} className={linkGroup.groupName}>{groupTitle}</h6>)
      }

      linkGroup.elements.forEach(link => {
        currentKey++;
        if (link.visible === false || link.enabled === false) { return; }
        if (link.filter && !link.filter(null, GameData.currentGame)) {
          return;
        }
        if (link.divider) {
          navObjects.push(<hr key={'nav-item-' + currentKey} />);
          return;
        }  

        const dltext = window.isSoloApp ? 'Save' : 'Download';
        if (link.isPlayButton) {
          navObjects.push(<Fragment key="play-buttons-holder">
              <div className="button-bar" key="play-download-buttons">
                    <Button className="big-button" size="sm" key="play-button" variant="primary" onClick={() => this.playGame()}>Play</Button>
              </div>
              <div className="button-bar" key="share-buttons">
                    <Button size="sm" key="download-button" variant="outline-primary" onClick={() => this.downloadGame()}>{dltext}</Button>
                    <LinkContainer to="/builder/share"><Button className="share-btn" size="sm" key="share-button" variant="outline-primary" onClick={event => this.testUnsavedChanges(event)}>Share</Button></LinkContainer>
                    <Button size="sm" key="run-btn" className="run-btn" variant="outline-primary" onClick={event => this.runLocal(event)}>Open Rom</Button>
              </div>
            </Fragment>
          );
          return;
        }
        navObjects.push(
          <LinkContainer to={link.href} key={'nav-item-' + currentKey} isActive={(match, location) => this.testIsActive(link, match, location)} onClick={event => this.testUnsavedChanges(event)}>
            {/* active: false works around a messy interaction between react-router and bootstrap and the boostrap wrapper... don't ask. */}
            <Nav.Link active={false}>
              {link.name}
            </Nav.Link>
          </LinkContainer>
        )
      });
    });

    return (
      <>
        <Nav navbar={true} variant="pills" className="app-navigation flex-column bg-dark text-white">
          <div className="nav-inner">
            {navObjects}
          </div>
        </Nav>
        <Modal className="pre-emulator-modal" size="md" backdrop="static" show={this.state.preEmulatorVisible} onHide={() => this.setState({ preEmulatorVisible: false })} aria-labelledby="Save Changes">
          <Modal.Header closeButton>
            <Modal.Title>Unsaved changes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>You have unsaved changes on the current page. These changes will not be reflected in the game until you save. Do you want to try the game without your unsaved changes?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={() => this.setState({ preEmulatorVisible: false })}>Cancel</Button>
            <Button variant="outline-secondary" onClick={() => { this.playGame() }}>Play Unsaved Version</Button>
          </Modal.Footer>
        </Modal>
        
        <Modal className="pre-navigation-modal" size="md" backdrop="static" show={this.state.preNavigationVisible} onHide={() => { this.setState({ preNavigationVisible: false }); this.lastClickedContainer = null }} aria-labelledby="Save Changes">
          <Modal.Header closeButton>
            <Modal.Title>Unsaved changes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>You have unsaved changes on the current page. If you continue to navigate, you will lose those changes. Are you sure you want to continue?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={() => { this.setState({ preNavigationVisible: false }); this.lastClickedContainer = null }}>Cancel</Button>
            <Button variant="outline-danger" onClick={() => { this.setState({ preNavigationVisible: false}); this.lastClickedContainer.click(); this.lastClickedContainer = null }}>Don't save</Button>
          </Modal.Footer>
        </Modal>
        
        <Modal className="emulator-modal" size="lg" fullscreen={"lg-down"} backdrop="static" show={this.state.emulatorVisible} onHide={() => this.closeEmulator()} aria-labelledby="Emulator Dialog">
          <Modal.Header closeButton>
            <Modal.Title>{GameData.currentGame?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EmbeddedEmulator ref={this.emulatorRef} key={this.state.emulatorRefresh} />
            <Button variant="outline-secondary mx-2" onClick={() => this.skipLevel() }>Skip Level</Button>
            <Button variant="outline-danger" onClick={() => { this.resetEmulator() }} >Reset emulator</Button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}